export default __webpack_public_path__ + "static/media/tealium.fa350c44.svg";